import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import BasketLineItemImage from '@/ui/views/checkout/BasketLineItemImage.vue';
import BasketLineItemPrice from '@/ui/views/checkout/BasketLineItemPrice.vue';
import ProductTileColorBaubles from '@/ui/shared/product-tile/ProductTileColorBaubles.vue';
import BasketLineItemQuantity from '@/ui/views/checkout/BasketLineItemQuantity.vue';
import BasketLineItemRemove from '@/ui/views/checkout/BasketLineItemRemove.vue';
import BasketLineItemProperties from '@/ui/views/checkout/BasketLineItemProperties.vue';
import BasketLineItemTitle from '@/ui/views/checkout/BasketLineItemTitle.vue';
import GiftItemColors from '@/ui/shared/GiftItemColors.vue';
import UpdateGiftWithPurchaseVariantWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.UpdateGiftWithPurchaseVariantWebRequest;
import GiftWithPurchaseColorViewObject = Vertica.LouisPoulsen.Application.Commerce.ViewModels.GiftWithPurchaseColorViewObject;
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketGiftLineItemB2C',
  props: {
    lineItem: null,
    vatText: null
  },
  setup(__props: any) {

const props = __props as {
    lineItem: LineItemViewObject,
    vatText: string
}



// TODO: Opacity 50 when locked
const isBasketLocked = computed<boolean>(() => store.getters['basket/isBasketLocked']);

function updateGiftWithPurchaseItem(request: UpdateGiftWithPurchaseVariantWebRequest) {
    store.dispatch('basket/updateGiftWithPurchaseItem', request);
}

// Gift line item functions
const showColors = ref<boolean>(true);

const hasColorVariants = computed<boolean>(() => props.lineItem.giftWithPurchase.colorScheme && props.lineItem.giftWithPurchase.colorScheme.every(color => !!color.hex));

const colorPickerColors = computed<IColorBaubles[]>(() => hasColorVariants.value
    ? props.lineItem.giftWithPurchase.colorScheme.map(color => ({
        colorImage: color.colorImage,
        hex: color.hex
    }))
    : []);

function setSelectedColor(color: GiftWithPurchaseColorViewObject) {
    const variant = props.lineItem.giftWithPurchase.colorScheme.find(c => c.hex === color.hex);
    if (!variant || variant.variantCode === props.lineItem.variantId) {
        return;
    }
    updateGiftWithPurchaseItem({ variantId: variant.variantCode, promotionId: props.lineItem.giftWithPurchase.promotionId });
}


return { __sfc: true,props, isBasketLocked, updateGiftWithPurchaseItem, showColors, hasColorVariants, colorPickerColors, setSelectedColor, BasketLineItemImage, BasketLineItemPrice, BasketLineItemProperties, BasketLineItemTitle, GiftItemColors }
}

})